type EligibilityDialogText = {
  button: string
  period: string
}

type ElibilityConfig = {
  name: string
  code: string
  eligibility_prompt_text: EligibilityDialogText
}
export const ELIGIBILITY_DIALOG_LANGUAGES: ElibilityConfig[] = [
  {
    name: 'English',
    code: 'en-US',
    eligibility_prompt_text: {
      button: 'Continue',
      period: '.',
    },
  },
  {
    name: 'Español',
    code: 'es-US',
    eligibility_prompt_text: {
      button: 'Continuar',
      period: '.',
    },
  },
  {
    name: 'Deutsch',
    code: 'de-DE',
    eligibility_prompt_text: {
      button: 'Weiter',
      period: '.',
    },
  },
  {
    name: 'Français',
    code: 'fr-FR',
    eligibility_prompt_text: {
      button: 'Continuer',
      period: '.',
    },
  },
  {
    name: 'हिन्दी',
    code: 'hi-IN',
    eligibility_prompt_text: {
      button: 'आगे बढ़ें',
      period: '।',
    },
  },
  {
    name: 'Português',
    code: 'pt-PT',
    eligibility_prompt_text: {
      button: 'Continuar',
      period: '.',
    },
  },
  {
    name: 'Português (Brasil)',
    code: 'pt-BR',
    eligibility_prompt_text: {
      button: 'Continuar',
      period: '.',
    },
  },
  {
    name: 'العربية',
    code: 'ar-XA',
    eligibility_prompt_text: {
      button: 'متابعة',
      period: '.',
    },
  },
  {
    name: 'Bahasa Indonesia',
    code: 'id-ID',
    eligibility_prompt_text: {
      button: 'Lanjutkan',
      period: '.',
    },
  },
  {
    name: 'Italiano',
    code: 'it-IT',
    eligibility_prompt_text: {
      button: 'Continua',
      period: '.',
    },
  },
  {
    name: '日本語',
    code: 'ja-JP',
    eligibility_prompt_text: {
      button: '次へ',
      period: '。',
    },
  },
  {
    name: 'Türkçe',
    code: 'tr-TR',
    eligibility_prompt_text: {
      button: 'Devam Et',
      period: '.',
    },
  },
  {
    name: 'Tiếng Việt',
    code: 'vi-VN',
    eligibility_prompt_text: {
      button: 'Tiếp tục',
      period: '.',
    },
  },
  {
    name: 'বাংলা',
    code: 'bn-IN',
    eligibility_prompt_text: {
      button: 'এগিয়ে যান',
      period: '।',
    },
  },
  {
    name: 'ગુજરાતી',
    code: 'gu-IN',
    eligibility_prompt_text: {
      button: 'આગળ વધો',
      period: '।',
    },
  },
  {
    name: 'કನ್ನಡ',
    code: 'kn-IN',
    eligibility_prompt_text: {
      button: 'ಮುಂದುವರೆಯಿರಿ',
      period: '.',
    },
  },
  {
    name: 'മലയാളം',
    code: 'ml-IN',
    eligibility_prompt_text: {
      button: 'തുടരുക',
      period: '.',
    },
  },
  {
    name: 'मराठी',
    code: 'mr-IN',
    eligibility_prompt_text: {
      button: 'पुढे जा',
      period: '।',
    },
  },
  {
    name: 'தமிழ்',
    code: 'ta-IN',
    eligibility_prompt_text: {
      button: 'தொடரவும்',
      period: '.',
    },
  },
  {
    name: 'తెలుగు',
    code: 'te-IN',
    eligibility_prompt_text: {
      button: 'కొనసాగించండి',
      period: '.',
    },
  },
  {
    name: 'Nederlands',
    code: 'nl-NL',
    eligibility_prompt_text: {
      button: 'Doorgaan',
      period: '.',
    },
  },
  {
    name: '한국어',
    code: 'ko-KR',
    eligibility_prompt_text: {
      button: '계속',
      period: '.',
    },
  },
  {
    name: '官话',
    code: 'cmn-CN',
    eligibility_prompt_text: {
      button: '继续',
      period: '。',
    },
  },
  {
    name: 'Polski',
    code: 'pl-PL',
    eligibility_prompt_text: {
      button: 'Kontynuuj',
      period: '.',
    },
  },
  {
    name: 'Русский',
    code: 'ru-RU',
    eligibility_prompt_text: {
      button: 'Продолжить',
      period: '.',
    },
  },
  {
    name: 'Kiswahili',
    code: 'sw-KE',
    eligibility_prompt_text: {
      button: 'Endelea',
      period: '.',
    },
  },
  {
    name: 'ไทย',
    code: 'th-TH',
    eligibility_prompt_text: {
      button: 'ดำเนินการต่อ',
      period: ' ',
    },
  },
  {
    name: 'اردو',
    code: 'ur-IN',
    eligibility_prompt_text: {
      button: 'آگے بڑھیں',
      period: '۔',
    },
  },
  {
    name: 'Українська',
    code: 'uk-UA',
    eligibility_prompt_text: {
      button: 'Продовжити',
      period: '.',
    },
  },
  {
    name: 'Kreyòl ayisyen',
    code: 'ht-HT',
    eligibility_prompt_text: {
      button: 'Kontinye',
      period: '.',
    },
  },
]
